<template>
    <div class="shopping-list-typeahead" ref="shoppinglist">
        <div class="top-row">
            <form class="search-form" @submit.prevent>
                <input
                    type="text"
                    class="searchbox"
                    placeholder="Search"
                    maxlength="500"
                    v-model="searchTerm"
                    @input="getSuggestions"
                    @focus="onFocus"
                    @keydown.esc="unpin"
                    @keydown.prevent.stop.down="onArrowDown"
                    @keydown.prevent.stop.up="onArrowUp"
                    @keydown.enter="onEnter"
                    ref="searchInput"
                />
                
                <button v-show="this.searchTerm.length" class="searchbox__reset" aria-label="Reset" @click="clearSearchTerm()">
                    <img src="/img/icon-close.svg" alt="">
                </button>

                <button type="submit" class="searchsubmit" aria-label="Search">
                    <img src="/img/icon-search.svg" class="searchbox__icon-search" alt="">
                </button>

            </form>
            <a href="#" @click="unpin" class="system-link btn-cancel" v-show="pinned" ref="cancelButton">Cancel</a>

        </div>

        <ul class="suggestion-list" 
            @scroll="onScrollSuggestionList" 
            v-show="searchTerm.length"
            ref="suggestionList">
            <li v-for="(suggestion, index) in suggestions" 
                :key="index" class="suggestion" 
                @click="addToList(index)"
                :class="{ 'suggestion--active': index === selectedIndex }"
                @mouseenter="selectedIndex = index"
                @mouseleave="selectedIndex = -1">

                <div class="thumbnail-container">
                    <img :src="suggestion.smallImageUrl" class="thumbnail" alt="" v-if="suggestion.smallImageUrl"/>
                    <div class="thumbnail"  v-if="!suggestion.smallImageUrl"/>
                    <div class="thumbnail--adding" v-show="suggestion.adding">
                        <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="21.5" cy="22.5" r="9.5" fill="#009FCE"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.5694 25.2764L25.9523 19.4147C26.2065 19.1812 26.6019 19.198 26.8353 19.4523C27.0688 19.7065 27.052 20.1019 26.7978 20.3353L19.9922 26.5853C19.7531 26.8049 19.3858 26.8049 19.1467 26.5853L17.2023 24.7996C16.948 24.5661 16.9312 24.1708 17.1647 23.9165C17.3982 23.6623 17.7935 23.6455 18.0478 23.879L19.5694 25.2764Z" fill="white"/>
                        </svg>
                    </div>
                </div>

                <span>{{ suggestion.displayName }}</span>
                
            </li>
            <li v-show="searchTerm.length && !this.loading" class="external-search">
                <a :href="'/search/?q=' + searchTerm" class="system-link">
                    Search for	&ldquo;{{searchTerm}}&rdquo; <img src="/img/buttons/icon-arrow-right.svg" alt>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "ShoppingListTypeahead",
    data() {
        return {
        searchTerm: "",
        suggestions: [],
        loading: false,
        pinned: false,
        selectedIndex: -1,
        };
    },
    computed: {
        activeShoppingList(){
            return heb.data.user.activeShoppingList || '';
        }
    },
    methods: {
        onArrowDown() {
            if (this.selectedIndex < this.suggestions.length) {
                this.selectedIndex = this.selectedIndex + 1;
            }
        },
        onArrowUp() {
            if (this.selectedIndex > 0) {
                this.selectedIndex = this.selectedIndex - 1;
            }
        },
        onEnter() {
            this.addToList(this.selectedIndex)
        },
        onFocus(){
            if(heb.screen.isSmall){
                // pin screen
                this.$refs.shoppinglist.classList.add("fullscreen");

                // iOS Safari giving us the middle of the page for some reason
                setTimeout(function(){ 
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                }, 500);

                // Body Scroll Locking
                document.querySelectorAll('body')[0].classList.add('modal-open')

                this.pinned = true;
            }
        },
        onScrollSuggestionList(){
            // Since iOS Safari doesn't dismiss the keyboard when scrolling
            // Were picking another element to focus
            this.$refs.cancelButton.focus();
        },
        onSuccess(listName){
            this.clearSearchTerm()
            this.unpin()

            this.$toasted.show('Added to ' + listName,{
                theme: 'bubble',
                position: 'bottom-center',
                duration: 3000
            })

            // Refresh the list
            // TODO: convert displaying the shopping list to json/ajax
            $('#shopListSortSelect').trigger('change')
        },
        onError(message){
            this.$toasted.show('Error adding to list: ' + message,{
                theme: 'bubble',
                type: 'error',
                position: 'bottom-center',
                duration: 3000
            })
        },
        unpin(){
            //unpin screen
            this.pinned = false;
            this.$refs.shoppinglist.classList.remove("fullscreen");
            document.querySelectorAll('body')[0].classList.remove('modal-open')
            this.clearSearchTerm()
        },
        addToList: _.throttle(function (selectedIndex){
            // throttled to prevent doubleclicks from firing addToList twice

            var suggestion = this.suggestions[selectedIndex]
            suggestion['adding'] = true;

            var item = {
                qty: 1,
                type: suggestion.sku ? 'sku' : 'unknownItem',
                // note: '',
                name: suggestion.displayName || '',
                itemId: suggestion.sku, //skuId, not productId
            }

            // shoppingList object as described in postman
            var obj = {
                profileId: window.heb.data.user.id,
                listId: window.heb.data.user.activeShoppingList.id,
                getAllItems: true,
                items: [item],
            }

            this.$store.dispatch("shoppingList/ADD_ITEMS_TO_LIST", obj)
            .then(response => {
                if(response.status === 200){
                    this.onSuccess(response.data.name)
                }else if(response.response.status === 400 || response.response.status === 401 ){
                    // User needs to log in - This legacy API does not allow warm/cold users to save lists.
                    // Pending new service: MYHEB-610
                    this.onError('Please log in')
                    window.location = '/my-account/login';

                    // reset `adding` flag
                    this.suggestions.forEach(suggestion => {suggestion.adding = false })
                }else{
                    // reset `adding` flag
                    this.suggestions.forEach(suggestion => {suggestion.adding = false })
                    this.onError(response.message)
                }
            })
        }, 500),
        clearSearchTerm(){
            this.suggestions = []
            this.searchTerm = ''
            this.selectedIndex = -1
        },
        getSuggestions(){
            // Allow the user to add the freeform product to their list before returning server's products
            this.loading = true;

            // put the freeform item as the first suggestion to allow users to select it before results come back
            if(this.searchTerm.length){
                this.suggestions = [{
                    displayName: this.searchTerm,
                    adding: false,
                    src: ''
                }]
            }

            // Expensive http request that is debounched
            this.debouncedGetSuggestions()
        },
        debouncedGetSuggestions: _.debounce(function () {
            
            axios
                .all([
                    axios.get(
                        "/mylist/includes/typeAheadShopping/shoppinglistguidesearchcontent.jsp?searchTerm=" +
                        this.searchTerm
                    )
                ])
                .then(
                axios.spread(response => {
                    this.loading = false;

                    // Add a flag for "adding"
                    response.data.suggestions.forEach(suggestion => {suggestion['adding'] = false })
                    this.suggestions = response.data.suggestions;

                    // put the freeform as the first suggestion
                    var searchTermObject = {
                        displayName: this.searchTerm,
                        adding: false,
                        src: ''
                    }
                    
                    this.suggestions.unshift(searchTermObject);
                })
                )
                .catch(error => {
                    this.loading = false;
                    // Error
                    if (error.response) {
                        vm.commit("errors/PUSH_ERROR", {
                        message: error.response.data.title,
                        code: error.response.status
                        });
                    } else if (error.request) {
                        vm.commit("errors/PUSH_ERROR", {
                        message: "Couldn't contact the website"
                        });
                        console.log(error.request);
                    } else {
                        console.log("Error", error.message);
                        vm.commit("errors/PUSH_ERROR", { message: error.message });
                    }
                    console.log(error.config);
                });

        }, 800),// end debounce
    }
};
</script>

<style lang="scss" scoped>
@import "../shared/assets/lib";

.shopping-list-typeahead{
    position: relative;
}

.fullscreen{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 1rem;
    background: #fff;
    z-index: z-index("header-typeahead");
}

.search-form {
    position: relative;
    flex-grow: 1;
    z-index: 1;
}

.top-row{
    display: flex; 
    align-items: center;
}

.searchbox {
    width: 100%;
    box-sizing: border-box;
    height: 44px;
    font-size: 1rem;
    box-shadow: none;
    color: #414142;
    padding-right: 44px;
}

.searchbox:focus {
    background-color: #fff;
    border: 1px solid #009FCE;
}

.searchsubmit {
    line-height: 30px;
}

.searchsubmit {
    position: absolute;
    top: 1px;
    right: 0;
    width: 44px;
    height: 42px;
    padding: 0;
    border: none;
    background-color: transparent;
    font-size: 16px;
    line-height: 27px;
    color: #414142;
    margin: 0;
}

.searchbox__reset {
    color: #414142;
    background-color: #fff;
    position: absolute;
    top: 1px;
    right: 44px;
    width: 44px;
    height: 42px;
    border: none;
    margin: 0;
    padding: 0;
    font-size: 1rem;
}

.btn-cancel{
    margin-left: 1rem;
    font-weight: 600;
    color: #009FCE;
}

.suggestion-list{
    background: #fff;
    border-radius: 4px;
    position: absolute;
    left: 0;
    width: 100%;
    margin: 0;
    z-index: 1;

    @media screen and (min-width: $breakpoint-tablet) {
        box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.15);
    }
}

.fullscreen .suggestion-list{
    overflow: auto;
    height: calc(100% - 60px);
}

.suggestion{
    display: flex;
    align-items: center;
    padding: 1rem;
    line-height: 22px;
    cursor: pointer;
}

.suggestion--active{
    background: #F3F6F7;
}

.thumbnail-container{
    position: relative;
    margin-right: 1rem;
    flex-shrink: 0;
}

.thumbnail {
    width: 43px;
    height: 43px;
    border-radius: 6px;
}

.thumbnail--adding{
    position: absolute;
    top: 0;
}

.external-search{
    text-align: center;
    padding: 1rem;

    .system-link{
        font-size: 1rem;
    }

    img {
        margin-bottom: 4px;
        margin-left: .5rem;
    }
}
</style>